import {Component, OnInit, inject} from '@angular/core';
import {Router} from '@angular/router';
import {OidcSecurityService} from 'angular-auth-oidc-client';
import {take} from 'rxjs';

@Component({
  selector: 'app-callback',
  standalone: true,
  templateUrl: './callback.component.html',
  styleUrl: './callback.component.scss',
})
export class CallbackComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly oidc = inject(OidcSecurityService);

  ngOnInit(): void {
    this.oidc.isAuthenticated$.pipe(take(1)).subscribe(({isAuthenticated}) => {
      const target = isAuthenticated ? '/admin/dashboard' : '/';
      void this.router.navigateByUrl(target, {replaceUrl: true});
    });
  }
}
